export * from './edit-tasteprofile.component'